import axios from 'axios'

export default {
    data() {
        return {
            tokenIsValid: false
        }
    },
    methods: {
        checkAccessToken(val) {
            axios.get("https://api.mapbox.com/geocoding/v5/mapbox.places/Los%20Angeles.json", {
                params: {
                    access_token: val
                }
            })
                .then(response => {
                    this.tokenIsValid = true
                    this.errors.mapbox_token = null
                })
                .catch(error => {
                    console.error(error)
                    this.tokenIsValid = false
                    this.errors.mapbox_token = [
                        'Access token is invalid'
                    ]
                })
        }
    },
}